<script lang="ts">
  import { onMount } from "svelte";
  import WorkoutChart from './WorkoutChart.svelte';
  import WorkoutTable from './WorkoutTable.svelte';
  import TrainingCardLong from '@/MyFitness/Today/TrainingCardLong.svelte';
  import { getRequest } from '../Util/utils';
  import { connectedWorkoutPlayers } from '@/Singletons/WorkoutPlayersWritable';
  import { Button, buttonVariants } from '@/lib/components/ui/button';
  import route from '../Util/routes';

  export let workout;
  export let showButtons = true;

  onMount(function () {
    connectedWorkoutPlayers.init();
  });

  $: workoutData = {
    ...workout,
    suitability: null,
  }

  // @ts-ignore
  let jq = window.$;
  let viewportSize: ResizeObserverSize[];
  let flexflow: string = "flex-direction: row;";

  $: if (viewportSize && viewportSize.length > 0) {
    flexflow = viewportSize[0].inlineSize < 1050 ? "flex-direction: column;" : "flex-direction: row";
  }

  async function copyWorkout() {
    return await window.fetch(route("WorkoutController@getWorkout", [workoutData.path]), {
      ...getRequest(),
      method: 'post',
      body: JSON.stringify({ submit:"copy", 
        path:workoutData.path, 
        name:workoutData.name,
        description:workoutData.description,
      }),
    })
    .then(results => results.json())
    .then(results => {
      window.location.href = results.redirect;
    });
  }
  jq(document).ready(function () {
    jq('#workout_delete').confirmation({
      btnOkClass: 'btn btn-xs btn-success',
      btnCancelClass: 'btn btn-xs btn-danger',
      btnOkLabel: '<i class="icon-ok-sign icon-white"></i> Delete',
      placement: 'left',
      onConfirm: function (event) {
        window.fetch(route("WorkoutController@deleteWorkout", [workoutData.path]), {
          ...getRequest(),
          method: 'delete',
        })
        .then(results => results.json())
        .then(results => {
          window.close();
        });
      }
    });
  });
</script>

<div class="workout-details" bind:borderBoxSize={viewportSize}>
  <div class="top" style={flexflow}>
    <span class="info">
      <TrainingCardLong exercise={workoutData} showChartImage={false} forceShowDescription={true} {showButtons}>
        <Button class="no-underline text-foreground" variant='outline' size="sm" href="/workout/{workout.path}">
          <i class={`fa-regular fa-pencil text-xs mr-1`}></i>Open in Designer
        </Button>
      </TrainingCardLong>
    </span>
    <span class="workout-chart">
      <WorkoutChart workout_id={workoutData.path}/>
    </span>
  </div>
  <WorkoutTable workout_id={workoutData.path}/>
  <div class="flex flex-row-reverse gap-1">
    {#if workoutData.owner == 'User'}
    <button id="workout_delete" class="btn btn-default" data-toggle="tooltip" title="Delete">
      <i class="fa-regular fa-trash-can" data-placement="left"></i> Delete                           
    </button>
    {/if}
    <button id="workout_copy" value="copy" class="btn btn-default" data-toggle="tooltip" title="Copy Workout" on:click|preventDefault={copyWorkout}>
      <i class="fa-regular fa-copy" data-placement="left"></i> Copy
    </button>
  </div>
</div>

<style lang="scss">

  .workout-chart {
    display: flex;
    flex-grow: 2;
    justify-content: center;
    margin: 20px;
    flex-basis: 66%;
  }

  .info {
    margin: 20px;
    flex-grow: 1;
    flex-basis: 33%;
  }

  .top {
    display: flex;
  }
</style>
